import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAdmin, selectIsLoggedIn } from "../redux/authSlice";


const RequireAuth = ({ requireLogin, requireAdmin }) => {
    const location = useLocation();


    const isAdmin = useSelector(selectIsAdmin);
    const isLoggedIn = useSelector(selectIsLoggedIn);

    const authorized = (requireAdmin && isAdmin && isLoggedIn) || (requireLogin && isLoggedIn) || (!requireAdmin && !requireLogin);

    if (requireLogin && !isLoggedIn) {

        // First, check to see if "?survey=[qualtricsSurveyId]" has been set
        // If not, see if there's a deep link, which will be saved as "redirectAfterAuth"

        const searchParams = new URLSearchParams(location.search);
        const surveyId = searchParams.get("survey");
        if (surveyId) {
            sessionStorage.setItem("qualtricsSurveyId", surveyId);
            sessionStorage.removeItem("redirectAfterAuth");
        } else {
            const redirectPath = `${location.pathname}${location.search}`; // Preserve params
            console.log(`setting sessionStorage redirectAfterAuth to ${redirectPath}`);
            sessionStorage.setItem("redirectAfterAuth", redirectPath);
            sessionStorage.removeItem("qualtricsSurveyId");
        }
    }

    return (
        authorized
            ?
            <Outlet />
            :
            isLoggedIn
                ?
                <Navigate to="/unauthorized" state={{ from: location }} replace />
                :
                <Navigate to="/login" state={{ from: location }} replace />
    );

}

export default RequireAuth;